import { wrap } from "@/code-editor";
import { handleSaveClick } from "@/file";
import { showSettings } from "@/settings";
import * as signals from "@/signals";
import { Column } from "@/types";
import { closeSidebars } from "@/utils";
import {
	faArrowRightArrowLeft,
	faCode,
	faFloppyDisk,
	faFolderOpen,
	faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX } from "react";

function NavigationBar(): JSX.Element {
	const items = [
		{
			icon: faGlobe,
			label: t("site"),
			onClick: (): void => {
				void closeSidebars();
				signals.currentColumn.value = Column.SITE_LIST;
			},
		},
		{
			icon: faFolderOpen,
			label: t("file"),
			onClick: (): void => {
				void closeSidebars();
				signals.currentColumn.value = Column.FILE_LIST;
			},
		},
		{
			icon: faCode,
			label: t("code"),
			onClick: (): void => {
				void closeSidebars();
				if (signals.currentColumn.value === Column.CODE_EDITOR) {
					showSettings();
					return;
				}
				signals.currentColumn.value = Column.CODE_EDITOR;
			},
		},
		{
			icon: faArrowRightArrowLeft,
			label: t("wrap"),
			onClick: wrap,
		},
		{
			icon: faFloppyDisk,
			label: t("save"),
			onClick: handleSaveClick,
		},
	];

	const elements = items.map((item) => {
		return (
			<button
				key={item.label}
				onClick={item.onClick}
				title={item.label}
				type="button"
			>
				<FontAwesomeIcon icon={item.icon} />
				{item.label}
			</button>
		);
	});

	return <nav>{elements}</nav>;
}

export default NavigationBar;
